module.exports = __webpack_public_path__ + "img/TAB_03_Passive.6bbb085e.svg";